<template
  src="./contactDetailsGs.html"
  lang="html"
/>

<style
  src="../../stylus/main.css"
  lang="css"
/>

<script>
import prvInput from '../../components/prv-input/prv-input.vue'
import prvDropdown from '../../components/prv-dropdown/prv-dropdown.vue'

import {
  businessName,
  alpha40,
  email,
  mobilePhone,
  required,
  minLength,
  maxLength
} from "../../vendors/vue-validate/validators";

export default {
  components: {
    'prv-input': prvInput,
    'prv-dropdown': prvDropdown
  },

  data() {
    return {
      form: {
        company: '',
        rfc: '',
        service: '',
        contact: '',
        email: '',
        phone: '',
        buyer: '',
        buyerEmail: ''
      },
      loading: false,
      showModal: false,
      formError: false,
      backendErrors: {
        rfc: ''
      }
    }
  },

  watch: {
    'form.rfc'() {
      this.backendErrors.rfc = ''
    }
  },

  validations: {
    form: {
      company: {
        required,
        businessName
      },
      rfc: {
        required,
        legalRfc: (value) => {
          if (!value) return true

          const val = value.toUpperCase().trim()

          // RFC México
          const rfcRegex = /^([A-ZÑ&]{3,4})\d{6}([A-Z\d]{3})$/

          //TIN internacional
          const tinRegex = /^(?=.*[A-Z])(?=.*\d)[A-Z0-9-]{6,20}$/

          return rfcRegex.test(val) || tinRegex.test(val)
        }
      },
      service: {
        required
      },
      contact: {
        required,
        alpha40
      },
      email: {
        required,
        email
      },
      phone: {
        required,
        mobilePhone,
        minLength: minLength(10),
        maxLength: maxLength(12)
      },
      buyer: {
        required,
        alpha40
      },
      buyerEmail: {
        required,
        email
      }
    }
  },

  methods: {
    async submitForm() {

      this.$v.$touch()

      if (this.$v.$invalid) {
        this.formError = true

        this.$nextTick(() => {
          const firstError = document.querySelector('.input-error')
          if (firstError) {
            firstError.scrollIntoView({ behavior: 'smooth' })
          }
        })

        return
      }

      this.formError = false

      try {
        this.loading = true

        const dataToSend = {
          nombreEmpresa: this.form.company,
          rfc: this.form.rfc,
          productoServicio: this.form.service,
          nombreApellidosContacto: this.form.contact,
          correoElectronico: this.form.email,
          telefono: this.form.phone,
          nombreComprador: this.form.buyer,
          correoComprador: this.form.buyerEmail
        }

        const response = await fetch(
          '/api/v1/datos/proveedoresgruposalinas',
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            cache: 'no-cache',
            body: JSON.stringify(dataToSend)
          }
        )

        let result = null
        try {
          result = await response.json()
        } catch (e) {
          result = null
        }

        if (!response.ok) {
          const message = (result && result.message) || ''

          if (
            response.status === 409 ||
            message.includes('ya esta registrado')
          ) {
            this.backendErrors.rfc = 'Este RFC ya está registrado'
          } else if (response.status === 400) {
            this.backendErrors.rfc = 'RFC invalido'
          }

          throw new Error(message || 'Error en la petición')
        }

        this.showModal = true

        this.form = {
          company: '',
          rfc: '',
          service: '',
          contact: '',
          email: '',
          phone: '',
          buyer: '',
          buyerEmail: ''
        }

        this.$v.$reset()
        this.backendErrors.rfc = ''

      } catch (error) {
        console.error(error)
      } finally {
        this.loading = false
      }
    },

    closeModal() {
      this.showModal = false
      window.location.href = 'https://qa.necsus.com.mx/signin#/'
    }
  }
}
</script>